import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button as TabButton } from '@mui/material';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Fab from '@mui/material/Fab';
import Clear from '@mui/icons-material/Clear';
import { stringIsNullOrEmpty } from '../../utils/strings';
import Typography from '../form/Typography';
import Inline, { inlineAlignment } from '../layout/Inline';
import { isNullOrUndefined } from '../../utils/objects';

class ModalWrapper extends Component {
    state = {
        index: 0
    };

    static getDerivedStateFromProps(newProps, oldState) {
        if (!isNullOrUndefined(newProps.activeTab) && oldState.activeTab !== newProps.activeTab) {
            return { index: newProps.activeTab };
        }
        return null;
    }

    handleClose = (event, reason) => {
        const { onClose, canClickOut } = this.props;
        if (!canClickOut && reason && reason === 'backdropClick') {
            return; // Do nothing if the backdrop is clicked
        }
        onClose && onClose(event);
    };

    render() {
        const { variant = 'primary' } = this.props;

        if (variant === 'simple') return this.renderSimple();

        if (stringIsNullOrEmpty(variant) || variant === 'primary') return this.renderPrimary();

        if (variant === 'task') return this.renderTask();

        if (variant === 'stepped') return this.renderStepped();

        return <span>unknown modal variant {variant}</span>;
    }

    renderSimple() {
        const { open, onClose, className, canClickOut = true, BackdropProps, children, actions } = this.props;
        return (
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                open={open}
                disableEscapeKeyDown={!canClickOut}
                BackdropProps={BackdropProps}
                onClose={this.handleClose}
            >
                <div className={`modal ${className || ''}`}>
                    <Fab color="primary" aria-label="Close" className="fab close" onClick={() => onClose()}>
                        <Clear />
                    </Fab>
                    <div className="paper">
                        {children}
                    </div>
                    {!!actions &&
                        <div className="modal-footer paper">
                            {actions}
                        </div>
                    }
                </div>
            </Modal>
        );
    }

    renderStepped() {
        const { open, steps = [], canClickOut = false, children, className } = this.props;
        const { index } = this.state;
        const currentStep = steps[index];
        return (
            <Modal
                open={open}
                onClose={this.handleClose}
                aria-labelledby="stepped-modal-title"
                aria-describedby="stepped-modal-description"
                disableEscapeKeyDown={!canClickOut}
                className={className}
            >
                <div className="modal modal--stepped">
                    <div className="modal-header">
                        {steps.map((step, i) => (
                            <div key={i}>
                                <TabButton
                                    className={`step-title-button ${index === i ? 'active' : ''}`}
                                    onClick={() => this.handleTabClick(step, i)}
                                >
                                    {step.abbreviation}
                                </TabButton>
                            </div>
                        ))}
                    </div>
                    <div className="modal-content paper">
                        {!!currentStep && this.renderStep(index, currentStep)}
                        {children}
                    </div>
                    {!!currentStep && !!currentStep.actions &&
                        <div className="modal-footer paper">
                            {currentStep.actions}
                        </div>
                    }
                </div>
            </Modal>
        );
    }

    handleTabClick(step, index) {
        this.setState({ index: index });
        if (step.hasOwnProperty('onChangeTab')) {
            step.onChangeTab(index);
        }
    }

    renderPrimary() {
        const { open, title, subtitle, children, actions, canClickOut = false } = this.props;

        return (
            <Modal
                open={open}
                onClose={this.handleClose}
                aria-labelledby="primary-modal-title"
                aria-describedby="primary-modal-description"
                disableEscapeKeyDown={!canClickOut}
            >
                <div className="modal modal--primary">
                    <div className="modal-header">
                        <Typography className="header" size="xs">
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography className="subtitle" size="xxlg">
                                {subtitle}
                            </Typography>
                        )}
                    </div>
                    <div className="modal-content paper">{children}</div>
                    {actions && <div className="modal-footer paper">{actions}</div>}
                </div>
            </Modal>
        );
    }

    renderTask() {
        const { open, title, taskid, children, canClickOut = false } = this.props;

        return (
            <Modal
                open={open}
                onClose={this.handleClose}
                aria-labelledby="primary-modal-title"
                aria-describedby="primary-modal-description"
                disableEscapeKeyDown={!canClickOut}
            >
                <div className="modal modal--task">
                    <div className="modal-header">
                        <div className="title-container">
                            <Inline center>
                                <Typography className="header" size="xs">
                                    {taskid && ` #${taskid}`}
                                </Typography>
                            </Inline>
                            {title && (
                                <Typography className="subtitle" size="xxlg">
                                    {title}
                                </Typography>
                            )}
                        </div>
                    </div>
                    <div className="modal-content paper">{children}</div>
                </div>
            </Modal>
        );
    }

    renderStep(index, step) {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <div className="step-title">
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <Typography variant="h1">
                                {step.title && <span className="step-title-number">{step.title}&nbsp;</span>}
                                <span className="step-title-detail">{step.subtitle}</span>
                            </Typography>
                            {!!step.button && <div className="step-button">{step.button}</div>}
                        </Inline>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="step-content">{step.content}</div>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles({})(ModalWrapper);
